import { AutoColumn } from "../../components/Column";
import styled from "styled-components";
import { RowBetween } from "../../components/Row";
import { ThemedText } from "../../theme";
import { Trans } from "@lingui/macro";
import NoDataContent from "../../components/NoDataContent";
import { Coffee, Plus } from "react-feather";
import { ButtonLight, ButtonPrimary } from "../../components/Button";
//import { useMiniPool } from '../../hooks/useContract';
import usePkgUsers from "../../hooks/usePkgUsers";
import useAppGroup from "../../hooks/useAppGroup";
import useToken from '../../hooks/useToken';
import { USERS_ADDRESS,TOKEN_ADDRESS, GROUPAPP_ADDRESS } from "../../constants/address";
// import { MINI_POOL_ADDRESS } from '../../constants/address';
import { useEffect, useMemo, useState } from "react";
import AppPkgItem from "./components/AppPkgItem";
// import UserNodeInfo from "./components/UserNodeInfo";

import UserAppItem from "./components/UserAppItem";
import UpdateAppModal from "./components/UpdateAppModal";
import UpdatePkgModal from "./components/UpdatePkgModal";
import { useWallet } from "use-wallet";
import Loader from "../../components/Loader";
import Big from "big.js";

const Wrapper = styled(AutoColumn)`
  max-width: 820px;
  width: 100%;
`;

const ThemedTextWrapper = styled(ThemedText.Black)`
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  font-weight: 400;
  font-size: 20px;
`;

const PoolsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 16px;
  column-gap: 16px;
  padding-bottom: 10px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    grid-template-columns: 1fr;
  `};
`;

function Nodes() {
  const { account, chainId } = useWallet();

  const [appOpen, setAppOpen] = useState(false);
  const [pkgOpen, setPkgOpen] = useState(false);
  const [curpkgitem, setCurpkgitem] = useState(null);
  // const blockNumber = getBlockNumber();
  const userOpt = usePkgUsers(USERS_ADDRESS[chainId]);
  const appgroupOpt = useAppGroup(GROUPAPP_ADDRESS[chainId]);

  const [loading, setLoading] = useState(true);
  const [myApps, setMyApps] = useState([]);
  const [myPkgInfoList, setMyPkgInfoList] = useState([]);
 const [minPledge, setMinPledge] = useState("0");

 const [token] = useToken(TOKEN_ADDRESS[chainId]);
 const tokenContract = useMemo(() => {
   if (token) {
     return token.contract;
   }
   return null;
 }, [token]);

  useEffect(() => {
    const fetch = async () => {
      const tmpnodeApps = await appgroupOpt.getAppsList(setLoading);
      // console.log("getPkgInfoList", nodeApps);
      setMyApps(tmpnodeApps);

      const  tmpminledge= await appgroupOpt.getPledge();
      setMinPledge(tmpminledge);

      const tmpuserpkglist = await userOpt.getPkgInfoList(
        setLoading
      );
      setMyPkgInfoList(tmpuserpkglist);
      //}
    };
    if (appgroupOpt.AppGroupContract&& appgroupOpt.getPledge && userOpt.userContract && appgroupOpt.getAppsList) {
      fetch();
    }
    // updateAppVersion getAppTypeList getMerchantList
    // nodeOpt, TODO 为什么不能nodeOpt 导致死循环
  }, [account, appgroupOpt.AppGroupContract,appgroupOpt.getPledge, userOpt.userContract, appgroupOpt.getAppsList]);

  return (
    <Wrapper>
      <AutoColumn gap={"24px"} style={{ width: "100%" }}>
        {myApps && !myApps.length && (
          <NoDataContent
         
            text={
              <>
                <div>
                  <Trans>
                    If you are an AI algorithm researcher or developer, you can
                    release your AI installation package. The deployment package
                    format can be an executable file, a published AI model, or a
                    Docker image. Community nodes can choose your AI
                    installation package, run it, and earn rewards.
                    
                  </Trans>
                </div>
                <div>{loading ? <Loader /> : null}</div>
              </>
            }
          />
        )}

        <RowBetween>
          <ThemedTextWrapper>
           <Trans>My Published Applications</Trans>

          </ThemedTextWrapper>
          <ButtonPrimary
              padding={"8px"}
              width={"180px"}
            
          onClick={() => {setAppOpen(true);}}
            >
              <Trans>Publish APP/Model</Trans>
            </ButtonPrimary>
        </RowBetween>
        <PoolsWrapper>
          {myApps &&
            myApps.map((appitem) => (
              <UserAppItem pkgitem={appitem}  appMinPledge={minPledge}  token={token} appgroupOpt={appgroupOpt} />
            ))}
        </PoolsWrapper>
        <RowBetween>
          <ThemedTextWrapper>
            <Trans>My Published Packages</Trans>
          </ThemedTextWrapper>
          <ButtonPrimary
              padding={"8px"}
              width={"180px"}
              onClick={() => {setPkgOpen(true);setCurpkgitem(null);}}
            >
              <Trans>Publish Packages</Trans>
            </ButtonPrimary>
        </RowBetween>
        {account && myPkgInfoList  && myPkgInfoList.length ? (
          <PoolsWrapper>
            {myPkgInfoList.map((pkgitem) => (
              <AppPkgItem
              token={token}
                key={pkgitem.appid}
                //minPledge={minPledge}
                setCurpkgitem={setCurpkgitem}
                setPkgOpen={setPkgOpen}
                pkgitem={pkgitem}
                userOpt={userOpt}
              />
            ))}
          </PoolsWrapper>
        ) : (
          <NoDataContent
          
            text={
              <>
                <div>
                  <Trans>Your Packages Info will appear here.</Trans>
                </div>
                <div>{loading ? <Loader /> : null}</div>
              </>
            }
          />
        )}
      </AutoColumn>

      <UpdateAppModal
        isOpen={appOpen}
        setIsOpen={setAppOpen}
        token={token}
        appMinPledge={minPledge}
        appgroupOpt={appgroupOpt}
      />

    <UpdatePkgModal
            isOpen={pkgOpen}
            setIsOpen={setPkgOpen}
            token={token}
           
            pkgitem={curpkgitem}
            userOpt={userOpt}
          />
    </Wrapper>
  );
}

export default Nodes;
